import type { ReactElement } from "react";
import { Highlight } from "../../ui/Highlight/Highlight";
import { StatusBadge } from "../../ui/StatusBadge/StatusBadge";
import type { ProblemType } from "./errors";
import styles from "./ErrorListItem.module.css";

export interface ErrorListItemProps {
  problem: ProblemType;
  codeMatches?: Set<number>;
  titleMatches?: Set<number>;
  onSelect: () => void;
}

export function ErrorListItem({
  problem,
  codeMatches,
  titleMatches,
  onSelect,
}: ErrorListItemProps): ReactElement {
  return (
    <button type="button" className={styles.item} onClick={onSelect}>
      <span className={styles.main}>
        <span className={styles.title}>
          <Highlight text={problem.title} matches={titleMatches} />
        </span>
        <span className={styles.code}>
          <Highlight text={problem.code} matches={codeMatches} />
        </span>
      </span>
      <span className={styles.meta}>
        <StatusBadge status={problem.status} />
        {problem.retryable ? (
          <span className={styles.retryable}>RETRYABLE</span>
        ) : null}
      </span>
    </button>
  );
}
